import { IFacility } from './facility';
import { IRequestInfoParams } from './request';

export enum PossibleTypes {
  ALL = 1,
  ONLINE_CARE = 2,
  SECOND_OPINION = 3,
}

export interface IDoctorItem {
  DoctorKey: Number;
  DoctorName: String;
  Profiles: String;
  DeptName: String;
  FacilityName: String;
  Image: any;
}

/**
 * @see {@link IDoctorItem}
 */
export interface IDoctorListItem extends IDoctorItem {
  DeptKey: Number;
  DeptId: String;
  FacilityKey: Number;
  FacilityName: String;
  ScheduledDays: String;
  MyDoctor: number;
  ImagePath?: any;
}

/**
 * doctorList: ALL
 * doctorListSplit: page로 분리
 * selectedDoctor: 선택한 의사
 * selectedPage: 선택한 페이지
 * displayDoctorRow: 페이지당 표시되는 의사 수
 */
export interface IDoctor {
  /** 선택한 병원 */
  selectedFacility: IFacility | null | undefined;

  /** 선택한 기관 */
  selectedDept: IFacilityDept | null;

  /** 전체 리스트 */
  doctorList: Array<IDoctorListItem>;

  /** 페이지 */
  doctorListSplit: Array<Array<IDoctorListItem>>;

  /** 선택한 의사 */
  selectedDoctor: Array<IDoctorListItem>;

  /** 선택한 페이지 */
  selectedPage: number;

  /** 페이지당 표시되는 의사 수, 0이면 페이지 사용 안함 */
  displayDoctorRow: Number;
}

export interface ISaveMyDoctorInfo {
  DoctorKey: number;
  MyDoctor: number;
}

export interface IDepts {
  DeptKey: Number;
  DeptName: String;
}

export interface IFacilityDept {
  FacilityKey: Number;
  FacilityName: String;
  DeptKey: Number;
  DeptName: String;
  DeptId: String;
}

/**
 * @see {@link IRequestInfoParams}, {@link IDoctorItem}
 */
export interface IRequestDoctorInfo extends IRequestInfoParams, IDoctorItem {}

export enum DoctorListEvents {
  SelectedDoctor = 'selectedDoctor',
  UpdatePDoctor = 'update:pDoctors' 
}
